import { render } from "./ManageProjectsModal.vue?vue&type=template&id=aae0c210"
import script from "./ManageProjectsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageProjectsModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ManageProjectsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aae0c210"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aae0c210', __exports__)) {
    api.reload('aae0c210', __exports__)
  }
  
  module.hot.accept("./ManageProjectsModal.vue?vue&type=template&id=aae0c210", () => {
    api.rerender('aae0c210', render)
  })

}


export default __exports__